<template>
  <div class="forms">
    <SessionStatus v-if="submitted" v-bind:submissionId="submissionId" display="true" fieldsToFilter="barcode_" @resetEnquiry="resetEnquiry" />
    <Submitted v-if="submitted" @resetEnquiry="resetEnquiry" />    
    <TheFamilyHistoryFeedbackForm v-else @submitEnquiry="submitEnquiry" />
    <PrivacyNotice />
  </div>
</template>

<script>
import TheFamilyHistoryFeedbackForm from '@/components/familyhistoryfeedback/TheFamilyHistoryFeedbackForm.vue'
import Submitted from '@/components/familyhistoryfeedback/Submitted.vue'
import SessionStatus from '@/components/session/SessionStatus.vue'
import PrivacyNotice from '../../components/PrivacyNotice.vue'

export default {
  name: 'TheFamilyHistoryFeedback',
  components: {
    TheFamilyHistoryFeedbackForm,
    Submitted,
    SessionStatus,
    PrivacyNotice
  },
  data: function() {
    return {
      submitted: false,
      submissionId: ''
    }
  },
  methods: {
    submitEnquiry: function(result) {
      this.submitted = result.response == 'OK';
      this.submissionId = result.submissionId;
      scroll(0, 0);
    },
    resetEnquiry: function() {
      this.submitted = false;
      scroll(0, 0); 
    }
  }
}
</script>

